import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { makeStyles, TextField, Select, MenuItem } from '@material-ui/core';
import ProductDataTable from './ProductDataTable';
import { GetTranslatedValue } from '../../Helpers/translationHelper';
import { CheckNumberField } from '../../Helpers/fieldValidator';
import PriceSchemeDialog from '../Dialogs/PriceSchemeDialog';
import EditDeleteOrderLineDialog from '../Dialogs/EditDeleteOrderLineDialog';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useHistory } from 'react-router-dom';

export default function AddFormProductsComponent(props) {

    const classes = useStyles();
    const [dialogVisible, setDialogVisible] = useState(false)
    const [products, setProducts] = useState([])
    const [filteredProducts, setFilteredProducts] = useState([])
    const [uoms, setUoms] = useState([])
    const [editOrderline, setEditOrderline] = useState(false)
    const [purchaseOrderTypes, setPurchaseOrderTypes] = useState([])
    const [priceSchemes, setPriceSchemes] = useState([])
    let history = useHistory()

    useEffect(() => {

        Promise.all([
            dataService.getLanguages(),
            dataService.getTranslations(),
            dataService.getTranslationValues(),
            dataService.getPurchaseOrderTypes(),
            dataService.getUoms(),
            dataService.getPriceSchemes(),
            dataService.getProducts()
        ]).then((results) => {

            let languages = results[0].Results
            let translations = results[1].Results
            let translationValues = results[2].Results
            let types = results[3].Results
            let units = results[4].Results
            let schemes = results[5].Results
            let prods = results[6].Results

            let languageID = languages.find(x => x.LanguageIsoCode === 'NL').ID;

            prods.forEach((e, index, array) => {
                e.value = GetTranslatedValue(languageID, e.NameTranslationID, translations, translationValues);
            });

            if (props.addPage.dataArea !== null) {
                prods = prods.filter(b => b.DataArea === props.addPage.dataArea);
            }

            prods = prods.sort((a, b) => (b.value - a.value))


            if (JSON.stringify(prods) !== JSON.stringify(products)) {
                setProducts(prods)
                setFilteredProducts(prods)
            }

            if (JSON.stringify(types) !== JSON.stringify(purchaseOrderTypes)) {
                setPurchaseOrderTypes(types)
            }

            if (JSON.stringify(units) !== JSON.stringify(uoms)) {
                setUoms(units)
            }

            if (JSON.stringify(schemes) !== JSON.stringify(priceSchemes)) {
                setPriceSchemes(schemes)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) });
    }, [])

    const onChangeItem = (event) => {
        props.actions.SetProduct(event.target.value);
        props.actions.SetPriceSchemeDialogVisible(true);
    }

    const checkForm = () => {
        let valid = true;
        let poType = purchaseOrderTypes.find((pot) => { return pot.ID === props.addPage.purchaseOrderTypeID });

        //quality
        let qtyValid = CheckNumberField(props.addPage.quantity);

        if (!qtyValid[0]) {
            toast.error(qtyValid[1], { position: toast.POSITION.TOP_CENTER })
            valid = false;
        }

        //price
        let priceValid = CheckNumberField(props.addPage.unitPrice100Kg);

        if (!priceValid[0]) {
            toast.error(priceValid[1], { position: toast.POSITION.TOP_CENTER })
            valid = false;
        }

        //Partenariat
        if (poType.Code == 'CONTRPRT') {

            //contract
            let contractValid = CheckNumberField(props.addPage.contractPrice);

            if (!contractValid[0]) {
                toast.error(contractValid[1], { position: toast.POSITION.TOP_CENTER })
                valid = false;
            }
        }

        //product
        if (props.addPage.productID === '' || props.addPage.productID === 0) {
            toast.error('enter a product', { position: toast.POSITION.TOP_CENTER })
            valid = false;
        }

        //from
        if (props.addPage.fromDate === '') {
            toast.error('enter from date', { position: toast.POSITION.TOP_CENTER })
            valid = false;
        }

        //to
        if (props.addPage.toDate === '') {
            toast.error('enter to date', { position: toast.POSITION.TOP_CENTER })
            valid = false;
        }

        if (new Date(props.addPage.toDate) < new Date(props.addPage.fromDate)) {
            toast.error('to date should be after from date', { position: toast.POSITION.TOP_CENTER })
            valid = false;
        }

        return valid;
    }

    const addPurchaseOrderline = () => {
        let check = checkForm();

        if (check) {
            let newID = props.addPage.purchaseOrderLineID + 1
            props.actions.SetNewId(newID);
            if (props.addPage.editmode) {
                props.actions.EditProductData({
                    id: props.addPage.editid,
                    fromDate: props.addPage.fromDate, //moment(new Date(date)).format('DD-MM-YYYY')
                    toDate: props.addPage.toDate,
                    productID: props.addPage.productID,
                    quantity: props.addPage.quantity,
                    unitOfMeasurementID: props.addPage.unitOfMeasurementID,
                    unitPrice100Kg: props.addPage.unitPrice100Kg,
                    contractPrice: props.addPage.contractPrice,
                    overdelivery: props.addPage.overdelivery
                });

                props.actions.SetEditMode(false);
            } else {
                props.actions.AddProductData({
                    id: newID,
                    fromDate: props.addPage.fromDate,
                    toDate: props.addPage.toDate,
                    productID: props.addPage.productID,
                    quantity: props.addPage.quantity,
                    unitOfMeasurementID: props.addPage.unitOfMeasurementID,
                    unitPrice100Kg: props.addPage.unitPrice100Kg,
                    contractPrice: props.addPage.contractPrice,
                    overdelivery: props.addPage.overdelivery
                });
            }
            cleanform();
        }
    }

    const cleanform = () => {
        // let poType = purchaseOrderTypes.find((pot) => { return pot.ID === props.addPage.purchaseOrderTypeID });

        props.actions.SetProduct(0)
        props.actions.SetFromDate('')
        props.actions.SetToDate('')
        props.actions.SetQuantity('')
        props.actions.SetPrice('')
        props.actions.SetContractPrice('')
    }

    const removeWeighing = (id) => {
        setEditOrderline(false)
        props.actions.SetDeleteID(id)
        setDialogVisible(true)
    }

    const editWeighing = (id) => {
        setEditOrderline(true)
        setDialogVisible(true)
        props.actions.SetEditID(id);
    }

    const CloseEditDeleteDialog = () => {
        setDialogVisible(false)
    }

    const DeleteOrderline = () => {
        props.actions.RemoveProductData(props.addPage.deleteid);
        setDialogVisible(false)
    }

    const EditOrderline = () => {
        let orderline = props.addPage.purchaseOrderLines.find((ol) => { return ol.id === props.addPage.editid });
        let poType = purchaseOrderTypes.find((pot) => { return pot.ID === props.addPage.purchaseOrderTypeID });

        props.actions.SetProduct(orderline.productID)
        props.actions.SetFromDate(orderline.fromDate)
        props.actions.SetToDate(orderline.toDate)
        props.actions.SetQuantity(orderline.quantity)
        props.actions.SetPrice(orderline.unitPrice100Kg)
        props.actions.SetContractPrice(orderline.contractPrice)
        props.actions.SetOverdelivery(orderline.overdelivery)

        // if (poType.Code == 'CONTRPRT') {
        //     this._contractpriceInput.setNativeProps({ text: orderline.contractPrice });
        // }

        props.actions.SetEditMode(true, props.addPage.editid);
        setDialogVisible(false)
    }

    const updatePurchaseOrderline = () => {
        addPurchaseOrderline();
    }

    const overProduceFields = () => {

        let poType = purchaseOrderTypes.find((pot) => { return pot.ID === props.addPage.purchaseOrderTypeID });

        if (poType == undefined) {
            return <div></div>
        }

        if (poType.Code == 'CONTRPRT') {
            return <div>
                <div className={classes.formLabel}>T/H at contract price</div>
                <TextField id="outlined-search" label="" type="number" defaultValue={props.addPage.contractPrice} value={props.addPage.contractPrice} variant="outlined" placeholder={"Enter contract price"} className={classes.uiTextField} size="small" onChange={(e) => props.actions.SetContractPrice(e.target.value)} />
            </div>
        } else {
            return <div></div>
        }
    }

    const GoNext = () => {
        if (props.addPage.purchaseOrderLines.length !== 0) {
            props.SetNext();
        } else {
            toast.error('Add products', { position: toast.POSITION.TOP_CENTER })
        }
    }

    const showPriceScheme = () => {
        if (props.addPage.productID === 0) {
            toast.error('Select a product first', { position: toast.POSITION.TOP_CENTER })
        }
        else {
            props.actions.SetPriceSchemeDialogVisible(true);
        }
    }

    const onChangeFilterTextPress = (event) => {
        let tempList = [...products]

        tempList = tempList.filter(x => x.value.toLowerCase().includes(event.target.value.toLowerCase()))
        setFilteredProducts(tempList)

        if (tempList.length === 0) {
            toast.error('There are no products with that name', { position: toast.POSITION.TOP_CENTER })
        }
    }

    return (
        <div className={classes.formContainer}>
            {priceSchemes.length > 0 && products.length > 0 && <React.Fragment>
                <div className={classes.formLabel}>Product</div>
                <div className={classes.searchcontainer}>
                    <div className={classes.filterField}>
                        <TextField id="outlined-search" label="Filter products" type="search" variant="outlined" className={classes.uiTextField} size="small" onChange={(e) => onChangeFilterTextPress(e)} />
                    </div>
                </div>

                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select2"
                    className={classes.productPicker}
                    value={props.addPage.productID}
                    placeholder={'Select a product'}
                    onChange={(e) => onChangeItem(e)}
                >
                    {filteredProducts.map(x => {
                        return (
                            <MenuItem value={x.ID}>{x.value}</MenuItem>)
                    })}

                </Select>
                <div className={classes.formLabel}>From</div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={props.addPage.fromDate ? props.addPage.fromDate : new Date()}
                        minDate={new Date()}
                        onChange={(e) => props.actions.SetFromDate(e)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        className={classes.datePicker}
                    />
                </MuiPickersUtilsProvider>

                <div className={classes.formLabel}>To</div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={props.addPage.toDate ? props.addPage.toDate : new Date()}
                        minDate={props.addPage.fromDate !== "" ? props.addPage.fromDate : new Date()}
                        onChange={(e) => props.actions.SetToDate(e)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        className={classes.datePicker}
                    />
                </MuiPickersUtilsProvider>

                <div className={classes.formLabel}>Price per 100Kg</div>
                <TextField id="outlined-search" placeholder={"Enter price per 100KG"} type="search" defaultValue={props.addPage.unitPrice100Kg} value={props.addPage.unitPrice100Kg} variant="outlined" className={classes.uiTextField} size="small" onChange={(e) => props.actions.SetPrice(e.target.value)} />

                <div className={classes.formLabel}>Quantity</div>
                <TextField id="outlined-search" placeholder={"Enter quantity"} type="search" defaultValue={props.addPage.quantity} value={props.addPage.quantity} variant="outlined" className={classes.uiTextField} size="small" onChange={(e) => props.actions.SetQuantity(e.target.value)} />

                {overProduceFields()}
                <div className={classes.buttonsContainer}>
                    {props.addPage.editmode ? <button className={classes.addButton} onClick={() => updatePurchaseOrderline()}>Update</button> : <button className={classes.addButton} onClick={() => addPurchaseOrderline()}>Add</button>}
                    <button className={classes.showSchemeButton} onClick={() => showPriceScheme()}>Show price scheme</button>
                </div>
                <ProductDataTable uoms={uoms} products={products} orderLines={props.addPage.purchaseOrderLines} removeWeighing={removeWeighing} editWeighing={editWeighing}></ProductDataTable>

                <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={GoNext}></NextPrevButtons>

                <EditDeleteOrderLineDialog editOrderline={EditOrderline} deleteOrderline={DeleteOrderline} edit={editOrderline} closeDialog={CloseEditDeleteDialog} dialogOpen={dialogVisible}></EditDeleteOrderLineDialog>

                <PriceSchemeDialog priceSchemes={priceSchemes} open={props.addPage.priceSchemeDialogVisible} {...props}></PriceSchemeDialog>
            </React.Fragment>}
        </div>
    )
}

const useStyles = makeStyles({
    formLabel: {
        color: 'gray',
        marginTop: 20,
        fontSize: 18,
        fontWeight: '300',
        height: 30,
        fontFamily: "Roboto",
    },
    datePicker: {
        width: "100%",
        marginTop: "0px !important"
    },
    displayLabel: {
        marginBottom: 15,
        marginTop: 5
    },
    buttonsContainer: {
        width: "300px",
        marginLeft: "auto",
        marginRight: "auto",
        height: "70px",
        paddingTop: "20px"
    },
    searchcontainer: {
        flexDirection: "row"
    },
    filterField: {
        width: "100%",
        flex: 1,
        justifyContent: 'center'
    },
    addButton: {
        fontFamily: "Roboto",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "#1976d2",
        color: "white",
        height: "30px",
        width: "80px",
        fontSize: "14px",
        float: "left",
        marginTop: "10px"
    },
    showSchemeButton: {
        fontFamily: "Roboto",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "#1976d2",
        color: "white",
        height: "30px",
        width: "160px",
        fontSize: "14px",
        float: "left",
        marginTop: "10px",
        marginLeft: "10px"
    },
    productPicker: {
        height: 44,
        backgroundColor: 'white',
        borderWidth: 1,
        marginBottom: 10,
        width: "100%"
    },
    productFilter: {
        height: 80,
        paddingTop: 20,
    },
    contractPriceTextInput: {
        height: 80,
        paddingTop: 15
    },
    uiTextField: {
        width: "100%",
        backgroundColor: "white"
    },
    formContainer: {
        width: "1000px",
        marginLeft: "auto",
        marginRight: "auto",
        boxSizing: "border-box"
    }
});